import { AircraftTimelineEntryType } from '../../../../../common/types/timeline/AircraftTimelineEntryType';
import { CrewTimelineEntryType } from '../../../../../common/types/timeline/CrewTimelineEntryType';
import { ContractTimelineEntryType } from '../../../../../common/types/timeline/ContractTimelineEntryType';
import { MaintenanceTimelineEntryType } from '../../../../../common/types/timeline/MaintenanceTimelineEntryType';

export const entryTypeInStateMap = {
  [AircraftTimelineEntryType.AircraftContract]: 'aircraftContractTimelineEntries',
  [AircraftTimelineEntryType.AircraftSchedule]: 'aircraftScheduleTimelineEntries',
  [AircraftTimelineEntryType.MaintenanceAircraftSchedule]: 'mxAircraftScheduleTimelineEntries',
  [AircraftTimelineEntryType.ScheduleTemplate]: 'scheduleTemplateTimelineEntries',
  [CrewTimelineEntryType.CrewSchedule]: 'crewScheduleTimelineEntries',
  [CrewTimelineEntryType.DutySchedule]: 'dutyScheduleTimelineEntries',
  [CrewTimelineEntryType.DutyTimes]: 'dutyTimeTimelineEntries',
  [CrewTimelineEntryType.PilotContract]: 'pilotContractTimelineEntries',
  [ContractTimelineEntryType.ClientContractPeriod]: 'clientContractPeriodTimelineEntries',
  [MaintenanceTimelineEntryType.MaintenanceCrew]: 'maintenanceTimelineEntries',
};
